export default __webpack_public_path__ + "static/media/2374.b0a04a1c.png";